export const getTerritoryDiscoveryPageUrl = (searchTerm?: string): string =>
  `/discover/territories${searchTerm ? `?term=${searchTerm}` : ''}`;
